import { render, staticRenderFns } from "./rules_fr.vue?vue&type=template&id=7b672176&"
import script from "./rules_fr.vue?vue&type=script&lang=js&"
export * from "./rules_fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports